const useShowAlert = () => useState('showAlert', () => false)

export { useShowAlert }
